import {
  DEFAULT_AUTOMIGRATE_COMMAND_LIST,
  ENTITY_MIGRATIONS_LIST,
} from 'client/const/migrate-consts'
import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import ServerPage from 'server/types/ServerPageInterface'
import migrateBlogContentPlaceholderCommand from 'tools/commands/migrate/BlogContentPlaceholder/migrateBlogContentPlaceholderCommand'
import migrateBlogLatestPostsCommand from 'tools/commands/migrate/BlogLatestPosts/migrateBlogLatestPostsCommand'
import migrateBlogPageBodyCommand from 'tools/commands/migrate/BlogPageBody/migrateBlogPageBodyCommand'
import migrateBlogPostCategoriesCommand from 'tools/commands/migrate/BlogPostCategories/migrateBlogPostCategoriesCommand'
import migrateBlogPostContentPlaceholderCommand from 'tools/commands/migrate/BlogPostContentPlaceholder/migrateBlogPostContentPlaceholderCommand'
import migrateBlogPostLayoutBodyCommand from 'tools/commands/migrate/BlogPostLayoutBody/migrateBlogPostLayoutBodyCommand'
import migrateBlogPostLIstingCommand from 'tools/commands/migrate/BlogPostListing/migrateBlogPostLIstingCommand'
import migrateBlogPostBodyCommand from 'tools/commands/migrate/blog-post-body/migrate-blog-post-body-command'
import migrateInlineCommand from 'tools/commands/migrate/Inline/migrateInlineCommand'
import { removeDuplicatedBlogPostLayoutBody } from 'tools/commands/remove-duplicated-blog-post-layout-body'

export const migratePage = (page: ServerPage): ServerPage => {
  const commandList = DEFAULT_AUTOMIGRATE_COMMAND_LIST

  switch (page.type) {
    case PageTypeEnum.BlogHome:
    case PageTypeEnum.BlogPostBody:
    case PageTypeEnum.BlogPostLayout:
    case PageTypeEnum.BlogPostListing:
    case PageTypeEnum.BlogStatic:
    case PageTypeEnum.BlogSearch:
      commandList.push(
        migrateBlogLatestPostsCommand,
        migrateBlogPostLIstingCommand,
        migrateBlogContentPlaceholderCommand,
        migrateBlogPostCategoriesCommand,
        migrateBlogPostContentPlaceholderCommand,
        migrateBlogPageBodyCommand,
        migrateBlogPostBodyCommand,
        migrateBlogPostLayoutBodyCommand,
        removeDuplicatedBlogPostLayoutBody,
      )
      break
    case PageTypeEnum.Inline:
      commandList.push(migrateInlineCommand)
      break
  }

  return commandList.reduce((page, command) => command(page)[0], page)
}

export const migratePageBlock = (
  structure: ServerPage['content']['entities'],
): ServerPage => {
  const commandList = ENTITY_MIGRATIONS_LIST

  // workaround for migrating blocks utilizing old page migration commands
  const pseudoPage: ServerPage = {
    id: 0,
    user_id: 0,
    created_at: new Date(),
    type: PageTypeEnum.BlogHome,
    locale: PageLocaleEnum.ENGLISH,
    content: {
      entities: structure,
      seo: {},
      globalSettings: {},
    },
  }

  return commandList.reduce((page, command) => command(page)[0], pseudoPage)
}
